(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_pk-form-field"] && !Shopify.designMode) return;
  try {
    (function () {
    function initPkForms(root) {
      var scope = root || document;
      var forms = scope.querySelectorAll('form');

      forms.forEach(function (form) {
        if (form.dataset.pkFormReady === 'true') return;

        form.dataset.pkFormReady = 'true';

        /*
          Mobile Safari can silently block custom required fields,
          especially visually-hidden radio buttons / option cards.
          This lets us handle validation ourselves and show visible errors.
        */
        form.setAttribute('novalidate', 'novalidate');

        var fields = Array.prototype.slice.call(form.querySelectorAll('[data-pk-form-field]'));
        var conditionalFields = fields.filter(function (field) {
          return field.hasAttribute('data-pk-conditional-field');
        });

        if (!fields.length) return;

        fields.forEach(storeOriginalRequiredState);

        var update = function () {
          syncFormValues(form);

          if (conditionalFields.length) {
            applyConditions(form, conditionalFields);
            applyConditions(form, conditionalFields);
            applyConditions(form, conditionalFields);
          }

          syncFormValues(form);
          clearErrorsForCompletedFields(form);
        };

        form.addEventListener('change', update);
        form.addEventListener('input', update);

        var submitButtons = form.querySelectorAll('button[type="submit"], input[type="submit"], button:not([type])');

        submitButtons.forEach(function (button) {
          button.addEventListener('click', function (event) {
            update();

            if (!validatePkForm(form)) {
              event.preventDefault();
              event.stopPropagation();
            }
          });
        });

        form.addEventListener('submit', function (event) {
          update();

          if (!validatePkForm(form)) {
            event.preventDefault();
            event.stopPropagation();
          }
        });

        update();
      });
    }

    function storeOriginalRequiredState(field) {
      var controls = field.querySelectorAll('input, select, textarea');

      controls.forEach(function (control) {
        if (!control.dataset.pkOriginalRequired) {
          control.dataset.pkOriginalRequired = control.required ? 'true' : 'false';
        }

        if (!control.dataset.pkOriginalAriaRequired) {
          control.dataset.pkOriginalAriaRequired = control.getAttribute('aria-required') === 'true' ? 'true' : 'false';
        }
      });
    }

    function syncFormValues(form) {
      syncSingleCheckboxes(form);
      syncCheckboxGroups(form);
      syncMultiselects(form);
    }

    function syncSingleCheckboxes(form) {
      var fields = form.querySelectorAll('[data-pk-single-checkbox-field]');

      fields.forEach(function (field) {
        var hiddenInput = field.querySelector('[data-pk-single-checkbox-value]');
        var checkbox = field.querySelector('[data-pk-single-checkbox]');

        if (!hiddenInput || !checkbox) return;

        hiddenInput.value = checkbox.checked ? checkbox.value || 'Yes' : '';
      });
    }

    function syncCheckboxGroups(form) {
      var groups = form.querySelectorAll('[data-pk-checkbox-group]');

      groups.forEach(function (group) {
        var hiddenInput = group.querySelector('[data-pk-checkbox-group-value]');
        var checkboxes = Array.prototype.slice.call(group.querySelectorAll('[data-pk-checkbox-option]'));

        if (!hiddenInput || !checkboxes.length) return;

        var selectedValues = checkboxes
          .filter(function (checkbox) {
            return checkbox.checked && !checkbox.disabled;
          })
          .map(function (checkbox) {
            return checkbox.value || '';
          })
          .filter(function (value) {
            return value !== '';
          });

        hiddenInput.value = selectedValues.join(', ');
      });
    }

    function syncMultiselects(form) {
      var fields = form.querySelectorAll('[data-pk-multiselect-field]');

      fields.forEach(function (field) {
        var hiddenInput = field.querySelector('[data-pk-multiselect-value]');
        var select = field.querySelector('[data-pk-multiselect-select]');

        if (!hiddenInput || !select) return;

        var selectedValues = Array.prototype.slice.call(select.selectedOptions)
          .map(function (option) {
            return option.value || '';
          })
          .filter(function (value) {
            return value !== '';
          });

        hiddenInput.value = selectedValues.join(', ');
      });
    }

    function applyConditions(form, conditionalFields) {
      conditionalFields.forEach(function (field) {
        var sourceKey = field.dataset.pkConditionSource || '';
        var operator = field.dataset.pkConditionOperator || 'equals';
        var conditionValue = field.dataset.pkConditionValue || '';
        var behavior = field.dataset.pkConditionBehavior || 'show';
        var sourceField = findFieldByKey(form, sourceKey);
        var sourceValue = getFieldValue(sourceField);
        var conditionMet = evaluateCondition(sourceValue, operator, conditionValue);
        var shouldShow = behavior === 'hide' ? !conditionMet : conditionMet;

        setFieldVisibility(field, shouldShow);
      });
    }

    function findFieldByKey(form, key) {
      if (!key) return null;

      var fields = form.querySelectorAll('[data-pk-form-field]');

      for (var i = 0; i < fields.length; i += 1) {
        if (fields[i].dataset.pkFieldKey === key) {
          return fields[i];
        }
      }

      return null;
    }

    function getFieldValue(field) {
      if (!field || field.hidden) return '';

      var checkedRadio = field.querySelector('input[type="radio"]:checked:not(:disabled)');
      if (checkedRadio) return checkedRadio.value || '';

      var select = field.querySelector('select:not(:disabled)');
      if (select) {
        if (select.multiple) {
          return Array.prototype.slice.call(select.selectedOptions).map(function (option) {
            return option.value || '';
          });
        }

        return select.value || '';
      }

      var checkboxes = Array.prototype.slice.call(field.querySelectorAll('input[type="checkbox"]:not(:disabled)'));

      if (checkboxes.length === 1) {
        return checkboxes[0].checked ? checkboxes[0].value || 'Yes' : '';
      }

      if (checkboxes.length > 1) {
        return checkboxes
          .filter(function (checkbox) {
            return checkbox.checked;
          })
          .map(function (checkbox) {
            return checkbox.value || '';
          });
      }

      var textControl = field.querySelector(
        'textarea:not(:disabled), input:not([type="hidden"]):not([type="radio"]):not([type="checkbox"]):not(:disabled)'
      );

      if (textControl) return textControl.value || '';

      return '';
    }

    function evaluateCondition(sourceValue, operator, conditionValue) {
      var hasValue = Array.isArray(sourceValue)
        ? sourceValue.some(function (value) {
            return normalize(value) !== '';
          })
        : normalize(sourceValue) !== '';

      switch (operator) {
        case 'not_equals':
          return !matchesEquals(sourceValue, conditionValue);
        case 'contains':
          return matchesContains(sourceValue, conditionValue);
        case 'not_contains':
          return !matchesContains(sourceValue, conditionValue);
        case 'is_empty':
          return !hasValue;
        case 'is_not_empty':
          return hasValue;
        case 'equals':
        default:
          return matchesEquals(sourceValue, conditionValue);
      }
    }

    function matchesEquals(sourceValue, conditionValue) {
      var compareValue = normalize(conditionValue);

      if (Array.isArray(sourceValue)) {
        return sourceValue.some(function (value) {
          return normalize(value) === compareValue;
        });
      }

      return normalize(sourceValue) === compareValue;
    }

    function matchesContains(sourceValue, conditionValue) {
      var compareValue = normalize(conditionValue);

      if (!compareValue) return false;

      if (Array.isArray(sourceValue)) {
        return sourceValue.some(function (value) {
          return normalize(value) === compareValue;
        });
      }

      return normalize(sourceValue).indexOf(compareValue) !== -1;
    }

    function normalize(value) {
      return String(value == null ? '' : value).trim().toLowerCase();
    }

    function setFieldVisibility(field, shouldShow) {
      var controls = field.querySelectorAll('input, select, textarea');

      field.hidden = !shouldShow;
      field.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');

      controls.forEach(function (control) {
        if (!shouldShow) {
          control.disabled = true;
          control.required = false;
          control.removeAttribute('aria-required');
          clearFieldError(field);
          return;
        }

        control.disabled = false;

        if (control.dataset.pkOriginalRequired === 'true') {
          control.required = true;
        }

        if (control.dataset.pkOriginalAriaRequired === 'true') {
          control.setAttribute('aria-required', 'true');
        }
      });
    }

    function validatePkForm(form) {
      syncFormValues(form);

      var fields = Array.prototype.slice.call(form.querySelectorAll('[data-pk-form-field]'));
      var firstInvalidField = null;

      fields.forEach(function (field) {
        if (!isFieldVisible(field)) return;

        var isValid = validateField(field);

        if (!isValid && !firstInvalidField) {
          firstInvalidField = field;
        }
      });

      if (firstInvalidField) {
        scrollToField(firstInvalidField);
        focusField(firstInvalidField);
        return false;
      }

      return true;
    }

    function validateField(field) {
      clearFieldError(field);

      if (!isFieldRequired(field)) {
        return validateOptionalFieldFormats(field);
      }

      var checkboxGroup = field.querySelector('[data-pk-checkbox-group]');
      if (checkboxGroup) {
        var checkedGroupOptions = checkboxGroup.querySelectorAll('[data-pk-checkbox-option]:checked:not(:disabled)');

        if (!checkedGroupOptions.length) {
          showFieldError(field, 'Please choose at least one option.');
          return false;
        }

        return true;
      }

      var requiredCheckbox = field.querySelector('input[type="checkbox"][required]:not(:disabled)');
      if (requiredCheckbox && !requiredCheckbox.checked) {
        showFieldError(field, 'Please tick this box to continue.');
        return false;
      }

      var requiredRadios = Array.prototype.slice.call(field.querySelectorAll('input[type="radio"][required]:not(:disabled)'));
      if (requiredRadios.length) {
        var radioName = requiredRadios[0].name;
        var checkedRadio = field.querySelector('input[type="radio"][name="' + cssEscape(radioName) + '"]:checked:not(:disabled)');

        if (!checkedRadio) {
          showFieldError(field, 'Please choose an option.');
          return false;
        }

        return true;
      }

      var requiredControls = Array.prototype.slice.call(
        field.querySelectorAll('input[required]:not([type="hidden"]):not([type="radio"]):not([type="checkbox"]):not(:disabled), select[required]:not(:disabled), textarea[required]:not(:disabled)')
      );

      for (var i = 0; i < requiredControls.length; i += 1) {
        var control = requiredControls[i];

        if (!controlHasValue(control)) {
          showFieldError(field, 'Please complete this field.');
          return false;
        }

        if (control.value && control.validity && !control.validity.valid) {
          showFieldError(field, getValidityMessage(control));
          return false;
        }
      }

      return true;
    }

    function validateOptionalFieldFormats(field) {
      var controls = Array.prototype.slice.call(
        field.querySelectorAll('input:not([type="hidden"]):not([type="radio"]):not([type="checkbox"]):not(:disabled), select:not(:disabled), textarea:not(:disabled)')
      );

      for (var i = 0; i < controls.length; i += 1) {
        var control = controls[i];

        if (control.value && control.validity && !control.validity.valid) {
          showFieldError(field, getValidityMessage(control));
          return false;
        }
      }

      return true;
    }

    function isFieldRequired(field) {
      if (field.querySelector('[data-pk-checkbox-group][data-required="true"]')) return true;
      if (field.querySelector('input[required]:not(:disabled), select[required]:not(:disabled), textarea[required]:not(:disabled)')) return true;

      return false;
    }

    function isFieldVisible(field) {
      if (!field) return false;
      if (field.hidden) return false;
      if (field.getAttribute('aria-hidden') === 'true') return false;

      return true;
    }

    function controlHasValue(control) {
      if (!control) return false;

      if (control.tagName === 'SELECT' && control.multiple) {
        return control.selectedOptions && control.selectedOptions.length > 0;
      }

      return String(control.value || '').trim() !== '';
    }

    function getValidityMessage(control) {
      if (control.type === 'email') return 'Please enter a valid email address.';
      if (control.type === 'url') return 'Please enter a valid link.';
      if (control.type === 'number') return 'Please enter a valid number.';

      return control.validationMessage || 'Please check this field.';
    }

    function showFieldError(field, message) {
      field.setAttribute('data-has-error', 'true');

      var error = field.querySelector('[data-pk-field-error]');

      if (!error) {
        error = document.createElement('p');
        error.className = 'pk-field__error';
        error.setAttribute('data-pk-field-error', '');

        var control = field.querySelector('.pk-field__control');
        if (control) {
          control.appendChild(error);
        } else {
          field.appendChild(error);
        }
      }

      error.textContent = message;
      error.hidden = false;
    }

    function clearFieldError(field) {
      field.removeAttribute('data-has-error');

      var errors = field.querySelectorAll('[data-pk-field-error]');

      errors.forEach(function (error) {
        error.hidden = true;
      });
    }

    function clearErrorsForCompletedFields(form) {
      var fields = Array.prototype.slice.call(form.querySelectorAll('[data-pk-form-field][data-has-error="true"]'));

      fields.forEach(function (field) {
        if (!isFieldVisible(field)) {
          clearFieldError(field);
          return;
        }

        if (validateFieldSilently(field)) {
          clearFieldError(field);
        }
      });
    }

    function validateFieldSilently(field) {
      if (!isFieldRequired(field)) return true;

      var checkboxGroup = field.querySelector('[data-pk-checkbox-group]');
      if (checkboxGroup) {
        return checkboxGroup.querySelectorAll('[data-pk-checkbox-option]:checked:not(:disabled)').length > 0;
      }

      var requiredCheckbox = field.querySelector('input[type="checkbox"][required]:not(:disabled)');
      if (requiredCheckbox) return requiredCheckbox.checked;

      var requiredRadios = Array.prototype.slice.call(field.querySelectorAll('input[type="radio"][required]:not(:disabled)'));
      if (requiredRadios.length) {
        return !!field.querySelector('input[type="radio"]:checked:not(:disabled)');
      }

      var requiredControls = Array.prototype.slice.call(
        field.querySelectorAll('input[required]:not([type="hidden"]):not([type="radio"]):not([type="checkbox"]):not(:disabled), select[required]:not(:disabled), textarea[required]:not(:disabled)')
      );

      for (var i = 0; i < requiredControls.length; i += 1) {
        if (!controlHasValue(requiredControls[i])) return false;
      }

      return true;
    }

    function scrollToField(field) {
      var top = field.getBoundingClientRect().top + window.pageYOffset - 120;

      window.scrollTo({
        top: top,
        behavior: 'smooth'
      });
    }

    function focusField(field) {
      var focusable = field.querySelector(
        'input:not([type="hidden"]):not(.visually-hidden):not(:disabled), select:not(:disabled), textarea:not(:disabled), button:not(:disabled)'
      );

      if (focusable) {
        window.setTimeout(function () {
          focusable.focus({ preventScroll: true });
        }, 250);
      }
    }

    function cssEscape(value) {
      if (window.CSS && window.CSS.escape) {
        return window.CSS.escape(value);
      }

      return String(value).replace(/"/g, '\\"');
    }

    document.addEventListener('DOMContentLoaded', function () {
      initPkForms(document);
    });

    document.addEventListener('shopify:section:load', function (event) {
      initPkForms(event.target);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
